import { useState } from "react";

import { ENTER_CODE } from "utils/constants";
import { handleInvalidRequest } from "utils/sdk";

import TextField from "components/TextField";

interface IChatInputField {
  onSubmit: (text: string) => Promise<any>;
}

const ChatInputField = ({ onSubmit }: IChatInputField) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleKeyPress = (e: any) => {
    if (!e.shiftKey && e.which === ENTER_CODE && !isSubmitting) {
      if (e.target.value) {
        setIsSubmitting(true);

        onSubmit(e.target.value)
          .then(() => (e.target.value = ""))
          .catch(handleInvalidRequest)
          .finally(() => setIsSubmitting(false));
      }
      e.preventDefault();
    }
  };

  return (
    <TextField
      autoFocus
      multiline
      placeholder="Type a message here..."
      rows={4}
      sx={{
        width: "100%",
      }}
      onKeyPress={handleKeyPress}
      data-testid="chat-input"
    />
  );
};

export default ChatInputField;
